<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Staffs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Staffs",
            items: [
               {
                  text: "Staffs",
                  active: true,
               },                   
            ],

            staffs: [],

            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,

            staff_status: {
               user_id: "",
               status: "",
            },

            listing_length: 10,
            keyword: '',
            staff_type: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchStaffs();
      },
      methods: {
         fetchStaffs(page_url = null) {

            this.getToken();
            let url = "store/staffs?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status ;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.staffs = responseData.staffs.data;
                     
                     this.pagination = responseData.staffs.links;
                     this.from = responseData.staffs.from;
                     this.to = responseData.staffs.to;
                     this.total = responseData.staffs.total;
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
            }, 

            getToken() {
            if (localStorage.getItem('sigofish_store')) {
               var sigofish_store =  JSON.parse(localStorage.getItem('sigofish_store'));
               if(sigofish_store.token) {
                  this.token = sigofish_store.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
            }, 

            // alphaSpacesOnly(event) {
            // let keyCode = event.keyCode;
            // if ((keyCode >= 65 && keyCode <= 90) || 
            //    (keyCode >= 97 && keyCode <= 122) ||               
            //    (keyCode == 32)) {
            //      return;
            // } else {
            //    event.preventDefault();
            // }
            // },

            showModal(modal) {
            this.$refs[modal].show();
            },

            hideModal(modal) {
            this.$refs[modal].hide();
            },

            setBackURL() {
		         localStorage.setItem('back_url', this.active_page_url);
		      },

         }


   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchStaffs()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchStaffs()"/>
                           </label>
                        </div> 
                        
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchStaffs()">    
                                 <option value="">Select</option>        
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                                 
                                 
                              </select>
                           </label>
                        </div>
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <!-- <th>Image</th> -->
                              <th>Name</th>              
                              <th>Phone</th>
                              <th>User Name</th>
                              <th>Address</th>
                              <th>State</th>
                              <th>Status</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody  v-if="Boolean(staffs.length)">
                           

                           <tr v-for="(staff) in staffs" :key="staff.id">
                              <!-- <td>
                                 <img src="@/assets/images/users/avatar-2.jpg" class="avatar-sm rounded-circle">
                              </td> -->
                              <td>{{staff.name}}</td>                      
                              <td>{{staff.country_code}} {{staff.mobile}}</td>
                              <td>{{staff.username}}</td>
                              <td>{{staff.address}}</td> 
                              <td>{{staff.states}}</td>
<td>
                                 <span v-if="staff.status == 1" class="badge rounded-pill bg-success">Active</span>
                                 <span v-if="staff.status == 2" class="badge rounded-pill bg-danger">Blocked</span>
                              </td>
                              <td class="w-200px">
                                 <router-link :to="{ name: 'staffs.details', params: {id: staff.id} }" class="btn btn-primary me-2 mb-2 btn-sm" @click.native="setBackURL()">Profile</router-link>

                                 </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="10" class="text-center">No Staffs found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(staffs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchStaffs(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status  )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
